import { apiSlice } from "../../../app/apiSlice";

const schoolImportApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getImportSources: builder.query({
      query: () => "/school/import-sources",
    }),
    startSchoolImport: builder.mutation({
      query: (values) => ({
        url: "/school/import",
        method: "POST",
        body: values,
      }),
    }),
    getImportStatus: builder.query({
      query: (taskId) => `/school/import-status/${taskId}`,
      keepUnusedDataFor: 0,
    }),
    getImportLog: builder.query({
      query: () => "/school/import-log",
      keepUnusedDataFor: 0,
    }),
    reverseImport: builder.mutation({
      query: () => ({
        url: "/school/import-reverse",
        method: "POST",
      }),
    }),
    cancelImport: builder.mutation({
      query: () => ({
        url: "/school/import-cancel",
        method: "POST",
      }),
    }),
    interruptImport: builder.mutation({
      query: () => ({
        url: "/school/import-interrupt",
        method: "POST",
      }),
    }),
    resumeImport: builder.mutation({
      query: () => ({
        url: "/school/import-resume",
        method: "POST",
      }),
    }),
  }),
});

export const {
  useGetImportSourcesQuery,
  useStartSchoolImportMutation,
  useGetImportStatusQuery,
  useGetImportLogQuery,
  useReverseImportMutation,
  useCancelImportMutation,
  useInterruptImportMutation,
  useResumeImportMutation,
} = schoolImportApiSlice;
